export default __webpack_public_path__ + "static/session2-c4fb63fe948884a9e61ec6fccd3b5713.png";